export default __webpack_public_path__ + "static/media/517.e42d5aa2.png";